import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import "./Loader.scss";

const DEFAULT_LOADER_DELAY = 250;
let setTimeoutInstance;

const Loader = ({ children, loading = true, delay = DEFAULT_LOADER_DELAY }) => {
  const [waiting, setWaiting] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (loading) {
      setWaiting(true);

      if (setTimeoutInstance) {
        clearTimeout(setTimeoutInstance);
      }
      setTimeoutInstance = setTimeout(() => {
        setWaiting(false);
      }, delay);
    } else {
      setWaiting(false);
    }
  }, [loading, delay]);

  if (waiting) {
    return (
      <div data-testid="loader" className="loader">
        <span>{t("loadingStates.loading")}</span>
      </div>
    );
  }

  return children;
};

Loader.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  delay: PropTypes.number,
};

export default Loader;
